import { render } from "./instructor-top-online.vue?vue&type=template&id=4f21602e"
import script from "./instructor-top-online.vue?vue&type=script&lang=js"
export * from "./instructor-top-online.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__